import React, { ReactNode } from 'react';
import { Flex, Tag, Typography, theme } from 'antd';

import { PrerenderTokenField } from '../../integrationWizard/components/steps/IntegrationStep/PrerenderTokenField';

const { Title, Paragraph } = Typography;

export type CloudflareStepHeaderProps = {
  title: ReactNode;
  description: ReactNode;
  descriptionMaxWidth?: number;
};

const CloudflareStepHeader = ({ title, description, descriptionMaxWidth }: CloudflareStepHeaderProps) => {
  const { token } = theme.useToken();

  return (
    <Flex align="flex-end" justify="space-between" gap={token.marginLG} wrap="wrap">
      <Flex vertical flex={1} gap={token.marginXXS} style={{ minWidth: 0, maxWidth: descriptionMaxWidth }}>
        <Flex align="center" gap={token.marginSM}>
          <Title level={2} style={{ margin: 0 }}>
            {title}
          </Title>
          <Tag color="purple">Beta</Tag>
        </Flex>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          {description}
        </Paragraph>
      </Flex>

      <PrerenderTokenField />
    </Flex>
  );
};

export default CloudflareStepHeader;
